import React from "react";
import "./passwordSuccess.css";
import { IoMdLock } from "react-icons/io";
import { CiCircleQuestion } from "react-icons/ci";
import { CheckSquare } from "lucide-react";
import { useNavigate } from "react-router-dom";
import {useTranslation} from "react-i18next";
export default function PasswordSuccess() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="password-success">
      <main className="password-success-main">
        <div className="password-success-card">
          <div className="password-success-icon">
            <CheckSquare size={64} strokeWidth={1.5} />
          </div>
          <p className="password-success-text">{t("auth.successPasswordReset")}</p>
          <h2 className="password-success-title">{t("auth.successfully")}</h2>
          <button
            className="password-success-btn"
            onClick={() => navigate("/sign-in")}
          >
           {t("auth.logIn")}
          </button>
        </div>
      </main>

      <footer className="password-success-footer">
        <span>{t("auth.copyright")}</span>
        <div>
          <a href="#"><IoMdLock />{t("auth.privacy")}</a>
          <a href="#"><CiCircleQuestion />{t("auth.getHelp")}</a>
        </div>
      </footer>
    </div>
  );
}
